import { useSelector } from "react-redux";
import clsx from "clsx";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import GalleryViewParticipantsName from "./GalleryViewParticipantsName";
import PinVideoForAllParticipantsButton from "./PinVideoForAllParticipantsButton";
import { isAgentIdentity } from "../../shared/utility";
import useLanguageChange from "../../hooks/useLanguageChange";
import { useParticipantCounts } from "../../hooks/useParticipantCounts/useParticipantCounts";
import ActiveSpeaker from "../Twilio/DominantSpeakerAnalyzer/ActiveSpeaker";

const GalleryView = () => {
    const { galleryViewConnectedUser } = useSelector((state) => state.galleryView);
    const { allUserAudioStatus } = useSelector((state) => state.twilioEvents);
    const localisedValues = useLanguageChange();
    const { countWithoutSilentObserver } = useParticipantCounts();

    return (
        <>
            {galleryViewConnectedUser.length > 0 && (
                <div className='gallery-view' data-testid='gallery-view'>
                    <div className={`gallery-view-list video-participant-${countWithoutSilentObserver}`}>
                        {galleryViewConnectedUser.map((data) => (
                            <div className='gallery-view-col' key={data?.identity} data-testid='gallery-view-col'>
                                <div
                                    className={clsx("gallery-view-box", !data?.isVideoStreaming && !data?.isScreenShareStreaming && "video-stop")}
                                    id={`galleryVideo_${data?.identity}`}
                                >
                                    <ActiveSpeaker
                                        userIdentity={data?.identity}
                                        fromWhere='gallery'
                                        isUserAudioEnabled={allUserAudioStatus[data?.identity]?.isAudioEnabled}
                                    />
                                    {!data?.isVideoStreaming && !data?.isScreenShareStreaming && (
                                        <>
                                            {isAgentIdentity(data?.identity) ? (
                                                <div className='agent-domain-logo'>
                                                    <img className='domain-img' src={GLOBAL_MEETING_DATA.companyLogo} alt='Domain_logo' />
                                                </div>
                                            ) : (
                                                <div className='participant-novideo'>
                                                    <div className='participant-novideo-in'>
                                                        <div className='participant-usericon'>
                                                            <span className='for-icon icon-user'></span>
                                                        </div>
                                                        <span className='for-bg'></span>
                                                        <span className='for-border'></span>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    <GalleryViewParticipantsName
                                        identity={data?.identity}
                                        isVideoStreaming={data?.isVideoStreaming}
                                        isScreenShareStreaming={data?.isScreenShareStreaming}
                                        localisedValues={localisedValues}
                                    />
                                    {GLOBAL_MEETING_DATA.isAgent && (data?.isVideoStreaming || data?.isScreenShareStreaming) && (
                                        <PinVideoForAllParticipantsButton
                                            stremingIdentity={data?.identity}
                                            isScreenShare={!!data.isScreenShareStreaming}
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default GalleryView;
